module.exports = __webpack_public_path__ + "34736292/img/arrow-left-icon.785c715c.svg";